import { Store } from 'pullstate';

export type Account = {
    id: string;
    name: string;
    nameError: boolean;
    industryName: string;
    industryId: string;
    hqAddress: string;
    hqProvince: string;
    hqPostalCode: string;
    hqCountryName: string;
    hqCountryId: string;
    hqRegionId: string;
    hqRegionName: string;
    revenueId: string;
    revenueName: string;
    employeeSizeId: string;
    employeeSizeName: string;
    accountStatusId: string;
    accountStatusName: string;
    doNotContact: boolean;
    logoFileName: string;
    keywords: AccountKeyword[];
    [key: string]: any;
};

export type AccountKeyword = {
    id: string;
    keyword: string;
    isDeleted: boolean;
};

const AccountStore = new Store({
    accounts: [] as Account[],
});

export { AccountStore };
export default AccountStore;
